import { ApiParams, ApiResponse } from '@models/api.model.ts';
import { ServiceTypeEnum } from '@models/services.model.ts';

const description = {
  en: 'Step into a world of calm and relaxation with our premium service.'
};

export const mockServices = [
  {
    id: '1',
    image: null,
    name: { en: 'Pool' },
    description,
    duration: '2h',
    price: 30,
    type: ServiceTypeEnum.Reservable,
    isPublished: true,
    departmentUnit: { id: 1, name: 'Recreation' },
    createdAt: '2026-05-01T10:00:00.000Z'
  },
  {
    id: '2',
    image: null,
    name: { en: 'Tennis Court' },
    description,
    duration: '2h',
    price: 30,
    type: ServiceTypeEnum.Reservable,
    isPublished: true,
    departmentUnit: { id: 1, name: 'Recreation' },
    createdAt: '2026-04-22T10:00:00.000Z'
  },
  {
    id: '3',
    image: null,
    name: { en: 'Spa Treatment' },
    description,
    duration: '45m',
    price: 80,
    type: ServiceTypeEnum.Requestable,
    isPublished: false,
    departmentUnit: { id: 2, name: 'Wellness' },
    createdAt: '2026-04-10T10:00:00.000Z'
  },
  {
    id: '4',
    image: null,
    name: { en: 'Room Cleaning' },
    description,
    duration: '30m',
    price: 0,
    type: ServiceTypeEnum.Requestable,
    isPublished: true,
    departmentUnit: { id: 3, name: 'Housekeeping' },
    createdAt: '2026-03-28T10:00:00.000Z'
  },
  {
    id: '5',
    image: null,
    name: { en: 'Airport Transfer' },
    description,
    duration: '1h',
    price: 55,
    type: ServiceTypeEnum.Reservable,
    isPublished: true,
    departmentUnit: { id: 4, name: 'Concierge' },
    createdAt: '2026-03-15T10:00:00.000Z'
  }
];

export const mockDepartmentUnits = [
  { id: 1, title: 'Recreation', value: 'Recreation' },
  { id: 2, title: 'Wellness', value: 'Wellness' },
  { id: 3, title: 'Housekeeping', value: 'Housekeeping' },
  { id: 4, title: 'Concierge', value: 'Concierge' }
];

// Mock API — imitates a network request (delay + Promise), no real backend call.
export const getMockServices = (
  params?: ApiParams
): Promise<ApiResponse<(typeof mockServices)[number]>> => {
  const page = params?.query?.page ?? 1;
  const limit = params?.query?.limit ?? 10;

  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        page,
        limit,
        total: mockServices.length,
        rows: mockServices
      });
    }, 600);
  });
};
